<div class="container cpal">
  <div class="fireworks-container" *ngIf="showFireworks"></div>
  <div class="row">
    <div style="width: inherit;">
      <h2 >Solicitud de Crédito Activa</h2>
    </div>      
    <ng-container *ngIf="solicitudActiva; else noSolicitudes">
    <mat-table [dataSource]="solicitudes" class="mb-5">
      <ng-container matColumnDef="monto">
        <mat-header-cell *matHeaderCellDef>Monto</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">{{ solicitud.monto | currency:'CLP':'symbol':'1.0-0' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="duracion">
        <mat-header-cell *matHeaderCellDef>Plazo (Meses)</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">{{ solicitud.duracion }} Meses</mat-cell>
      </ng-container>

      <ng-container matColumnDef="estado">
        <mat-header-cell *matHeaderCellDef>Estado Solicitud</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">
          <div class="semaforo">
           <div [ngClass]="getSemaforoClass(solicitud.estadoSolicitudCredito)">
              <span>{{ solicitud.estadoSolicitudCredito | capitalizeEnum }}</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaSolicitud">
        <mat-header-cell *matHeaderCellDef>Fecha Solicitud</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">{{ (solicitud.fechaSolicitud | date:'dd-MM-yyyy') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaTermino">
        <mat-header-cell *matHeaderCellDef>Fecha Término</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">{{ (agregarDias(solicitud.fechaSolicitud,5) | date:'dd-MM-yyyy') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
        <mat-cell *matCellDef="let solicitud">
          <mat-icon mat-icon-button (click)="cancelarSolicitud(solicitud)" matTooltip="Cancelar Solicitud" [ngClass]="{'desabilitarBoton': desabilitarBoton}" style="color: brown;">
            cancel</mat-icon>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="['monto', 'duracion', 'estado', 'fechaSolicitud', 'fechaTermino', 'acciones']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['monto', 'duracion', 'estado', 'fechaSolicitud','fechaTermino', 'acciones']"></mat-row>
    </mat-table>

  <ng-container *ngIf="normalize(solicitudActiva?.estadoSolicitudCredito) === normalize('Cancelada usuario'); else checkCaducada">
    <div class="estado-container">
      <div class="estadoFueraFlujo estado">Cancelada</div>
  </div>
  </ng-container>
  
  <ng-template #checkCaducada>
    <ng-container *ngIf="normalize(solicitudActiva?.estadoSolicitudCredito) === normalize('Caducada'); else showDiagram">
      <div class="estado-container">
        <div class="estadoFueraFlujo estado">Caducada</div>
    </div>
    </ng-container>
  </ng-template>
  
  <ng-template #showDiagram>
    <div class="estado-diagrama">
      <div class="estado-container">
        <div class="estado estado-creada" [ngClass]="colorCreada">
          Creada
        </div>

        <div class="linea"></div>

        <div class="estado estado-en-revision" [ngClass]="colorRevision">
          Pendiente Revisión
        </div>

        <div class="linea"></div>
    
        <div class="estado" [ngClass]="colorOfertada">
          En Subasta
        </div>
        
        <div class="linea"></div>

        <div class="estado" [ngClass]="colorPendienteSeleccion">
          Seleccionar Oferta
        </div>
    
        <div *ngIf="solicitudActiva && normalize(solicitudActiva.estadoSolicitudCredito) === 'PendienteDocumentacion'" class="estado documentacion-pendiente">
          Documentación Pendiente
        </div>
        <div class="linea"></div>
        <div class="estado" [ngClass]="colorFinalizada">Finalizada</div>
      </div>
    </div>
  </ng-template>

    <div class="fr mt-4" style="text-align: end;">
      <button class="mr1" mat-raised-button color="primary" [routerLink]="'/nueva-solicitud-credito'" [disabled]="tieneSolicitudActiva">Nueva Solicitud de Crédito</button>
    </div>
    <div class="container cpal">
      <div class="row mb-5">
        <h2>Resultado Subasta</h2>
      </div>
      <div *ngIf="noOfertas; else showTable">
        <p>No hay ofertas disponibles para esta solicitud.</p>
      </div>

      <ng-template #showTable>
        <mat-table [dataSource]="ofertas" class="mb-5">
          <ng-container matColumnDef="montoAprobado">
            <mat-header-cell *matHeaderCellDef>Monto Aprobado</mat-header-cell>
            <mat-cell *matCellDef="let oferta">{{ oferta.montoAprobado | currency:'CLP':'symbol':'1.0-0'}}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="tasaInteresAnual">
            <mat-header-cell *matHeaderCellDef>Tasa Interés Anual</mat-header-cell>
            <mat-cell *matCellDef="let oferta">{{ oferta.tasaInteresAnual }}%</mat-cell>
          </ng-container>

          <ng-container matColumnDef="posicionEnElRanking">
            <mat-header-cell *matHeaderCellDef>Ranking</mat-header-cell>
            <mat-cell *matCellDef="let oferta">{{ oferta.rankingActual}}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
            <mat-cell *matCellDef="let oferta">
              <mat-icon mat-icon-button [routerLink]="['/solicitudes', oferta.solicitudCreditoId, 'ofertas', oferta.guid]"
              [ngClass]="{'disabled-button': this.normalize(solicitudActiva.estadoSolicitudCredito) === this.normalize('FinalizadaConGanador')}">
                visibility
              </mat-icon>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="['montoAprobado', 'tasaInteresAnual','posicionEnElRanking', 'acciones']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['montoAprobado', 'tasaInteresAnual','posicionEnElRanking', 'acciones']"></mat-row>
        </mat-table>
      </ng-template>
    </div>
  </ng-container>
    <ng-template #noSolicitudes>
      <p class="text-center mt-4">Las ofertas estarán disponibles una vez finalizada la subasta.</p>
      <div class="fr mt-4">
        <button class="mr1" mat-raised-button color="primary" [routerLink]="'/nueva-solicitud-credito'" [disabled]="tieneSolicitudActiva">Nueva Solicitud de Crédito</button>
      </div>
    </ng-template>

  </div>
</div>
